/**
 * @generated SignedSource<<77f8f69c57b49daaeac6cae072685840>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StateMembershipSessionActivityArea = "community" | "curriculum" | "organization" | "product" | "%future added value";
export type RecordSessionLocationInput = {
  area: StateMembershipSessionActivityArea;
  productId?: string | null;
};
export type MembershipSessionProvider_recordSessionLocationMutation$variables = {
  input: RecordSessionLocationInput;
};
export type MembershipSessionProvider_recordSessionLocationMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type MembershipSessionProvider_recordSessionLocationMutation = {
  response: MembershipSessionProvider_recordSessionLocationMutation$data;
  variables: MembershipSessionProvider_recordSessionLocationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RecordSessionLocationResponseType",
    "kind": "LinkedField",
    "name": "recordSessionLocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MembershipSessionProvider_recordSessionLocationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MembershipSessionProvider_recordSessionLocationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1e16cf72e4450ae29200931e2c4c503b",
    "id": null,
    "metadata": {},
    "name": "MembershipSessionProvider_recordSessionLocationMutation",
    "operationKind": "mutation",
    "text": "mutation MembershipSessionProvider_recordSessionLocationMutation(\n  $input: RecordSessionLocationInput!\n) {\n  response: recordSessionLocation(input: $input) {\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ad41f4bb12680290d3bb95dd73a5fc1";

export default node;
